<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"/>

    <!-- 산업안전보건관리비-->
    <group-data-table
      class="mt-6"
      ref="group-data-table"
      title="산업안전보건관리비"
      annotation="(단위:백만원)"
      :groups="groups"
      :fixedItems="fixedItems"
      v-model="form.산업안전보건관리비"
    >
      <template v-slot:colgroup>
        <col width="218">
        <col width="80">
        <col width="80">
        <col width="80">
        <col width="80">
        <col width="80">
      </template>
      <template v-slot:thead>
        <tr>
          <th rowspan="2" colspan="1" class="cursor-pointer" @click="toggleOpenAll">항목</th>
          <th rowspan="1" colspan="3" >예산</th>
          <th rowspan="2" colspan="1" >집행 금액</th>
          <th rowspan="2" colspan="1" >집행률(%)</th>
        </tr>
        <tr>
          <th>사업계획</th>
          <th>증액(필요시)</th>
          <th>계</th>
        </tr>
      </template>
      <template v-slot:group-tr="{ group, data }">
        <td><div class="print-input">{{ getTotalData("사업계획", group, data) | comma }}</div></td>
        <td><div class="print-input">{{ getTotalData("증액", group, data) | comma }}</div></td>
        <td><div class="print-input">{{ getTotalData("계", group, data) | comma }}</div></td>
        <td><div class="print-input">{{ getTotalData("집행금액", group, data) | comma }}</div></td>
        <td><div class="print-input">{{ getTotalData("집행률", group, data) | fixed(2) }}</div></td>
      </template>
      <template v-slot:tr="{ group, data }">
        <td><number-input v-model="data['사업계획']" @input="onChangeData(data)"/></td>
        <td><number-input v-model="data['증액']" @input="onChangeData(data)"/></td>
        <td><div class="print-input">{{ data['계'] || 0 | comma }}</div></td>
        <td><number-input v-model="data['집행금액']" @input="onChangeData(data)"/></td>
        <td><div class="print-input">{{ data['집행률'] | fixed(2) }}</div></td>
      </template>
      <template v-slot:tfoot>
        <tr>
          <th class="py-4">계</th>
          <td><div class="print-input">{{ getTotalData("사업계획", "", form.산업안전보건관리비) | comma }}</div></td>
          <td><div class="print-input">{{ getTotalData("증액", "", form.산업안전보건관리비) | comma }}</div></td>
          <td><div class="print-input">{{ getTotalData("계", "", form.산업안전보건관리비) | comma }}</div></td>
          <td><div class="print-input">{{ getTotalData("집행금액", "", form.산업안전보건관리비) | comma }}</div></td>
          <td><div class="print-input">{{ getTotalData("집행률", "", form.산업안전보건관리비) | fixed(2) }}</div></td>
        </tr>
      </template>
    </group-data-table>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import {required} from "vuelidate/lib/validators";
import NumberInput from "@/components/NumberInput.vue";
import GroupDataTable from "@/components/group-data-table/GroupDataTable.vue";

export default {
  components: {
    GroupDataTable,
    NumberInput,
    DateSelector,
    WriteGridContainer,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        field_name: { required },
      },
    },
  },
  data() {
    return {
      groups: [
        "안전보건 시설투자", "안전관계자인건비", "외주공사안전관리비", "안전보호구 및 안전용품", "건강검진 및 의료비",
        "안전보건컨설팅 및 안전검사", "작업환경측정", "교육훈련비 및 안전포상 등", "소방안전 및 기타", "기타(산업안전보건관리비)"
      ],
      fixedItems: {"외주공사안전관리비": ["투자비(공사)", "수선비(공사)"]},
      form: {
        stdInfo: {},
        산업안전보건관리비: {},
        total: {},
        fileList: [],
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {

        if (Object.keys(value.산업안전보건관리비).length > 0) {
          for (const key of ["계", "사업계획", "증액", "집행금액", "집행률"]) {
            value.total[key] = this.getTotalData(key, "", value.산업안전보건관리비);
          }
        }

        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.field_name.required) return "사업장명을 반드시 입력해야 합니다";
      }
    },

    toggleOpenAll () {
      this.$refs["group-data-table"].toggleOpenAll();
    },

    getTotalData(key, group, data) {
      const _totalData = (key, group, _data) => {
        if (_data && _data.length > 0) {
          if (key === '집행률') {
            const 집행금액 = _data.reduce((acc, cur) => {
              return Number(acc || 0) + Number(cur.data['집행금액'] || 0);
            }, 0);
            const 계 = data.reduce((acc, cur) => {
              return Number(acc || 0) + Number(cur.data['계'] || 0);
            }, 0);
            return (집행금액 * 100) / 계;
          } else {
            return _data.reduce((acc, cur) => {
              return Number(acc || 0) + Number(cur.data[key] || 0);
            }, 0);
          }
        }
        return 0;
      }
      if (group) {
        return _totalData(key, group, data);
      } else if (key === '집행률') {
        let 계 = 0;
        let 집행금액 = 0;
        for (const group of this.groups) {
          계 += _totalData('계', group, data[group].data);
          집행금액 += _totalData('집행금액', group, data[group].data);
        }
        return (집행금액 * 100) / 계;
      } else {
        return this.groups.reduce((acc, cur) => {
          return Number(acc || 0) + Number(_totalData(key, cur, data[cur].data) || 0);
        }, 0);
      }
    },
    onChangeData (data) {
      const {
        사업계획 = 0,
        증액 = 0,
        집행금액 = 0
      } = data;
      data["계"] = Number(사업계획 || 0) + Number(증액 || 0);
      data["집행률"] = (Number(집행금액 || 0) * 100) / data["계"];
    }
  }
};
</script>
<style lang="scss" scoped>
.print-input {
  background-color: #fafafa;
}
</style>
